import { Component, OnInit } from '@angular/core';
// import codes from './gc.js' ;
// import codes from './gc.js';

@Component({
  selector: 'app-gcods',
  templateUrl: './gcods.component.html',
  styleUrls: ['./gcods.component.scss']
})
export class GcodsComponent implements OnInit {
 // text = codes.G17;
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/gcods/gcods.component.ts